import React, { useEffect, useState } from 'react';
import { HttpStatusCode } from 'axios';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';
import { useScheduleStore } from './schedule_store';
import { ScheduleSearchPanel } from './search_panel';
import { ScheduleSearchQuery } from './search_param';
import { ScheduleList, ScheduleStatus } from '../../components/schedule/schedule';
import { WorkListReponse } from '../../../model/work_response';
import { ApiError, ApiResponse } from '../../../api/api';
import styles from './index.module.scss';
import { Messages } from '../../../constant/messages';

/**
 * スケジュール一覧画面
 * @constructor
 */
export const ScheduleView: React.FC = () => {
  const [data, setData] = useState<WorkListReponse>();
  const { getSchedules } = useScheduleStore((selector) => selector);
  const [status, setStatus] = useState<ScheduleStatus>(ScheduleStatus.none);
  const [viewDate, setViewDate] = useState<dayjs.Dayjs>(dayjs());
  const navigator = useNavigate();

  const onSearch = (param: ScheduleSearchQuery) => {
    // スケジュール一覧取得
    setStatus(ScheduleStatus.loading);
    getSchedules(
      param.date,
      param.count,
      param.type,
      param.sections,
      param.division,
      param.floor,
      param.block,
      param.start,
      param.end,
      param.textType,
      param.content,
      param.timeSlot,
    ).then(
      (response: ApiResponse) => {
        if (!response.isError) {
          const res = response.data as WorkListReponse;
          setData(res);
          setStatus(ScheduleStatus.show);
          if (res.length > 0) {
            setViewDate(param.date);
          }
        } else if (response.status === HttpStatusCode.NotFound) {
          setStatus(ScheduleStatus.error_no_data);
        } else if (response.status === HttpStatusCode.Unauthorized || response.status === HttpStatusCode.Forbidden) {
          window.alert(Messages.ERR_DIALOG_RETURN_LOGIN);
          navigator('/login', { state: { message: Messages.ERR_401 } });
        } else {
          setStatus(ScheduleStatus.error_other);
        }
      },
    ).catch((e) => {
      if (e instanceof ApiError) {
        if (e.response.status === -1) {
          window.alert(Messages.ERR_DIALOG_TIMEOUT);
          setStatus(ScheduleStatus.error_timeout);
        }
      }
    });
  };

  return (
    <div>
      <h1>スケジュール一覧</h1>
      <ScheduleSearchPanel onSearch={onSearch} />
      <div className={styles.scheduleContainer}>
        <ScheduleList scheduleList={data} status={status} viewDate={viewDate}/>
      </div>
    </div>
  );
};
